import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { Card } from "@/components/ranger/PageHeader";
import { api } from "@/lib/api";

const pad = (n) => String(n).padStart(2, "0");
const UNITS = ["Days", "Hours", "Min", "Sec"];
const parts = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return [Math.floor(s / 86400), Math.floor((s % 86400) / 3600), Math.floor((s % 3600) / 60), s % 60];
};
const fmtLocal = (iso, tz) => new Date(iso).toLocaleString("en-US", { timeZone: tz, weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" });

const Clock = ({ ms }) => (
  <div data-testid="purge-countdown" className="flex gap-4">
    {parts(ms).map((v, i) => (
      <div key={UNITS[i]} className="text-center">
        <div className="font-display text-4xl font-bold tabular-nums text-slate-100 sm:text-5xl">{pad(v)}</div>
        <div className="rg-label mt-1">{UNITS[i]}</div>
      </div>
    ))}
  </div>
);

export const PurgeCountdown = ({ cid }) => {
  const [data, setData] = useState(null);
  const [now, setNow] = useState(Date.now());
  const [epoch, setEpoch] = useState(0);
  useEffect(() => { api.get(`/communities/${cid}/purge`).then((r) => setData(r.data)).catch(() => setData(null)); }, [cid, epoch]);
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!data?.schedule) return null;
  const { schedule: s, config: cfg } = data;
  const start = new Date(s.purge_start).getTime();
  const wipe = new Date(s.wipe_at).getTime();
  const active = now >= start;
  if (now >= wipe + 2000 && epoch === 0) setEpoch(1);
  return (
    <Card title={active ? "Purge is live" : "Next purge"} icon={Flame} testId="purge-card" className={`mb-5 ${active ? "border-red-500/50" : ""}`}
      right={<span data-testid="purge-state" className={`font-mono text-xs uppercase tracking-widest ${active ? "text-red-400 rg-pulse" : "text-amber-400"}`}>{active ? "PvP enabled" : "PvE in effect"}</span>}>
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="rg-label mb-2">{active ? "Wipe in" : "Purge starts in"}</div>
          <Clock ms={(active ? wipe : start) - now} />
        </div>
        <dl className="space-y-2 text-sm">
          <div><dt className="rg-label">Purge starts</dt><dd data-testid="purge-start-time" className="text-slate-200">{fmtLocal(s.purge_start, cfg.timezone)}</dd></div>
          <div><dt className="rg-label">Wipe</dt><dd data-testid="purge-wipe-time" className="text-slate-200">{fmtLocal(s.wipe_at, cfg.timezone)}</dd></div>
        </dl>
      </div>
      {!cfg.time_confirmed && <p data-testid="purge-time-unconfirmed" className="mt-4 text-xs text-amber-400">Wipe time of day is a placeholder (12:00 PM). Confirm it in Settings → Purge schedule.</p>}
    </Card>
  );
};
